//ecd:-767616932H20261022084009_V3.0
import { request, requestOrNull, seg, Page } from './apiSupport';
import { ProductDTO } from './ProductDTO';
import { ProductKeyDTO } from './ProductKeyDTO';
import { ProductSrchDTO } from './ProductSrchDTO';

/**
 * REST client for Product.
 *
 * Calls the endpoints ProductController exposes. Generated from the same model the
 * server is, so a change to the DSL shows up here as a type error rather than
 * at runtime.
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
const BASE = '/api/petstore/product';

/** Registers a new Product. */
export async function create(input: ProductDTO): Promise<ProductDTO> {
    return request<ProductDTO>('POST', BASE, input);
}

/** The Product with this identifier, or null when there is none. */
export async function findById(productId: number): Promise<ProductDTO | null> {
    return requestOrNull<ProductDTO>('GET', BASE + '/' + seg(productId));
}

/** Every Product matching the condition. */
export async function search(condition: ProductSrchDTO): Promise<Page<ProductDTO>> {
    return request<Page<ProductDTO>>('POST', BASE + '/search', condition);
}

/** Updates an existing Product. */
export async function update(input: ProductDTO): Promise<ProductDTO> {
    return request<ProductDTO>('PUT', BASE, input);
}

/** Updates several in one transaction; none are applied if any fails. */
export async function batchUpdate(inputs: ProductDTO[]): Promise<void> {
    return request<void>('PUT', BASE + '/batch', inputs);
}

/** Deletes each key, answering for each whether it was there. */
export async function deleteMany(keys: ProductKeyDTO[]): Promise<boolean[]> {
    return request<boolean[]>('POST', BASE + '/delete', keys);
}

/** Deletes the Product with this identifier. */
export async function deleteById(productId: number): Promise<boolean> {
    return request<boolean>('DELETE', BASE + '/' + seg(productId));
}

